import { render, staticRenderFns } from "./Writingtypes.vue?vue&type=template&id=b7849c28&scoped=true&"
import script from "./Writingtypes.vue?vue&type=script&lang=js&"
export * from "./Writingtypes.vue?vue&type=script&lang=js&"
import style0 from "./Writingtypes.vue?vue&type=style&index=0&id=b7849c28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7849c28",
  null
  
)

export default component.exports